
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed, watch } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptionsLhl.vue'
import api from '@/api/allApi'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'

import f10ApiHk from '@/api/f10ApiHk'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { ClockCircleOutlined, Descriptions, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      info: {},
      spinning: true
    })
    pageData.list = [
      { title: '公司名称', key: 'orgNameCn', isFull: false, align: 'left' },
      { title: '所属行业', key: 'industryName', isFull: false, align: 'left' },

      { title: '成立日期', key: 'establishedDate', isFull: false, align: 'left' },
      { title: '员工人数', key: 'staffNum', isFull: false, align: 'left' },

      { title: '年结日', key: 'annualCloseDate', isFull: false, align: 'left' },
      { title: '主营业务', key: 'mainOperationBusiness', isFull: false, align: 'left' },

      {
        title: '公司简介',
        key: 'orgCnIntroduction',
        isFull: true,
        fullLabel: false, // 新增字段，表示 label 不占固定宽度，而是随内容平均分配
        align: 'left'
      }
    ]


    onMounted(() => {
      const route: any = useRoute()
      const data: any = {}
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700',

      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }
      f10ApiHk.getBriefDetail(data).then((res: any) => {
        if (res && res.data) {
          const raw = res.data.companyInfoDetail

          // 格式化
          const formatDate = (timestamp: number) => {
            if (!timestamp) return '—'
            const date = new Date(timestamp)
            return `${date.getFullYear()}-${(date.getMonth() + 1)
              .toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
          }

          const formatAnnualDate = (str: string) => {
            if (!str || str.length !== 4) return str
            return `${str.slice(0, 2)}月${str.slice(2)}日`
          }

          const formatNumber = (num: number) => {
            return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }

          // 处理后的数据
          const info: any = {
            orgNameCn: raw.orgNameCn || '—',  // 公司名称
            industryName: raw.industryName || '—', // 行业
            establishedDate: formatDate(raw.establishedDate), // 成立日期
            staffNum: formatNumber(raw.staffNum) || '—', // 员工人数
            annualCloseDate: formatAnnualDate(raw.annualCloseDate) || '—', // 年终日
            mainOperationBusiness: raw.mainOperationBusiness || '—', // 主营业务
            orgCnIntroduction: raw.orgCnIntroduction || '—', // 公司简介
          }

          pageData.info = info
          pageData.spinning = false
        }

      })


    })
    // watch(
    //   () => props.pageSourceData,
    //   () => {
    //     const _data = props.pageSourceData || {}
    //     _data.ProvinceCity = _data.Province + _data.City
    //     _data.RegCapital = _data.RegCapital = globalsets.getNumber(_data.RegCapital)
    //     pageData.info = _data
    //     nextTick(() => {
    //       pageData.spinning = false
    //     })
    //   },
    //   { deep: true }
    // )
    return {
      ...toRefs(pageData)
    }
  }
})
